"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _mq = _interopRequireDefault(require("./mq"));

/* global $ */
// check existence of needed methods in $ global variable
// to use it for internal needs
var neededMethods = ['on', 'off', 'add'];
var globalDollar = typeof $ === 'function' ? $ : null;
var useGlobalDollar = true;
/* istanbul ignore if */

if (globalDollar) {
  var fn = globalDollar.fn || globalDollar.prototype;

  for (var i = 0; i < neededMethods.length; i++) {
    if (!fn[neededMethods[i]]) {
      useGlobalDollar = false;
      break;
    }
  }

  if (!globalDollar.parseHTML) {
    // Zepto doesn't include its own parseHTML
    // TODO: Assignment of parseHTML is side effect
    globalDollar.parseHTML = _mq["default"].parseHTML;
  }
} else {
  useGlobalDollar = false;
}

var _default = useGlobalDollar ? globalDollar : _mq["default"];

exports["default"] = _default;
//# sourceMappingURL=default-dollar.js.map